module.exports = __webpack_public_path__ + "img/DSC01040.fa91dc8e.jpg";